export type MessageInput = {
  role?: string;
  content?: unknown;
};

export type MessagePart = {
  role: "system" | "user";
  content: string;
  // The zero-based position in the call's original messages array.
  messagePartId: number;
};

const stringifyContent = (content: unknown): string => {
  if (typeof content === "string") return content;
  if (Array.isArray(content)) {
    return content
      .map((part) => {
        if (typeof part === "string") return part;
        if (part && typeof part === "object" && "text" in part) {
          return String((part as { text?: unknown }).text ?? "");
        }
        return "";
      })
      .filter(Boolean)
      .join("\n");
  }
  return content ? JSON.stringify(content) : "";
};

export const selectCompressibleMessageParts = (messages: MessageInput[]): MessagePart[] =>
  messages.flatMap((message, messagePartId) => {
    const role = message?.role;
    const content = stringifyContent(message?.content);
    if ((role !== "system" && role !== "user") || !content.trim()) return [];
    return [{ role, content, messagePartId }];
  });
